import * as React from 'react';

import { IQrCodeScannerFieldDefinition } from '../interfaces/Fields';
import { Slug } from "../../core/utils";
import { FormControlProps, FormControlWithFormsProps } from '../interfaces/FormControlProps';
import { FormFieldStateHelpers } from './helpers/FormFieldStateHelpers';
import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { StringHelpers } from '../../reactcomponents/helpers/StringHelpers';
import ReactHtmlParser from 'react-html-parser';
import { AjaxCallHelpers } from './helpers/AjaxCallHelpers';
import { InputState } from './Input';

export interface QRCodeInputState extends InputState {
  dataSourceCounter: number;
  timer: any;
  isButtonClicked: boolean;
  qrCodeComponent: any;
  isLoading: boolean;
}

class QRCodeScanner extends React.Component<FormControlWithFormsProps, QRCodeInputState> {
  
  private _qrCodeScannerFieldDefinition: IQrCodeScannerFieldDefinition;
  constructor(props: FormControlWithFormsProps) {
    super(props);
    this.state = {
      dataSourceCounter: 0,
      timer: undefined,
      isButtonClicked: false,
      qrCodeComponent: undefined,
      isLoading: false,
      isErrorLoading: false,
      hasFocus: false
    };
    this._qrCodeScannerFieldDefinition = this.props.formFieldDefinition as IQrCodeScannerFieldDefinition;
  }

  componentDidMount() {
    import('react-qr-reader').then((QRCode) => {
      if (!this.unmounted) {
        this.setState({ qrCodeComponent: QRCode.default });
      }
    });
  }

  unmounted = false;
  componentWillUnmount() {
    this.unmounted = true;
  }

  componentDidUpdate() {

    if (this.unmounted) {
      return;
    }

    if (!this.props.field.value || this.props.field.value === "" ||
      (this.props.forms[this.props.formController.props.formName] || {})[this.props.formFieldDefinition.name] === "") {
      this.lastScannedCode = "";
    }
  }

  shouldComponentUpdate(nextProps: FormControlWithFormsProps, nextState: QRCodeInputState): boolean {
    if (nextProps.field.value != this.props.field.value ||
      nextProps.form != this.props.form ||
      nextProps.formFieldDefinition != this.props.formFieldDefinition ||
      nextProps.formConfig != this.props.form ||
      nextProps.formController != this.props.formController ||
      nextProps.defaultValue != this.props.defaultValue ||
      nextState.qrCodeComponent != this.state.qrCodeComponent ||
      nextState.hasFocus != this.state.hasFocus ||
      nextProps.forms[nextProps.formController.formName][nextProps.formFieldDefinition.name] !== nextProps.field.value
    ) {
      return true;
    }
    return false;
  }

  lastScannedCode: "";
  handleQRCodeScan = (data) => {

    if (this.unmounted) {
      return;
    }
    if (data !== undefined && data !== null && data !== "") {

      let shouldTriggerSubmit = false;
      // should trigger submit is used for the strike registration scanner where the QR-code is a (temporary) membershipnumber, intead of json.
      if (data !== this.lastScannedCode
        && !this._qrCodeScannerFieldDefinition.isUsedToScanJson) {
        shouldTriggerSubmit = true;
      }
      this.lastScannedCode = data;

      FormFieldStateHelpers.updateFormikField(this as React.Component<FormControlProps, InputState>, data || "");

      setTimeout(() => {
        if (this.unmounted) {
          return;
        }
        if (this.props.formController.unmounted) {
          return;
        }

        if (FormControlHelpers.isValid(this)) {
          // Only get data when input is valid

          if (this.props.formController.props.onFieldChange) {
            this.props.formController.props.onFieldChange(
              this.props.formController.props.formName,
              this.props.formFieldDefinition.name,
              data);
          }
          
          if (this._qrCodeScannerFieldDefinition.isUsedToScanJson) {
            let inputAsJsonObject = StringHelpers.TryJsonParse(data);
            if (inputAsJsonObject) {
              for (var i in inputAsJsonObject) {
                this.props.formikBag.setFieldValue(i, inputAsJsonObject[i], true);
              }
            }
          }

          AjaxCallHelpers.getRelatedData(this, data);
          if (shouldTriggerSubmit) {
            this.props.formikBag.submitForm();
          }
        }
      }, 1);
    }
  }

  handleQRCodeScanError = (error) => {
    // skip validation rule
    // tslint:disable-next-line
    console.log("QRCodeScanner error", error);
  }

  onInputFocus = (event) => {
    this.setState({ hasFocus: true });
  }

  onInputBlur = (event) => {
    if (event.persist) {
      event.persist();
    }
    this.setState({ hasFocus: false }, () => {
      this.props.field.onBlur(event);
    });
  }


  render() {
    const inputProperties = {
      // Input properties has everything needed to deal with manual input
      // It will load related data when a datasource is set
      ...FormControlHelpers.inputProperties(this)
    };

    let QRComponent = undefined;
    if (this.state.qrCodeComponent) {
      QRComponent = this.state.qrCodeComponent;
    }

    return (
      <>
        <div className={FormStylingHelpers.getFormGroupStyle(this.props) + ' form__section-input qrcode-input-form-group ' + Slug.fromString(this.props.formFieldDefinition.name) + "-input-form-group "}>
          <div className="input-group">
            {QRComponent && <QRComponent
              onScan={this.handleQRCodeScan}
              onError={this.handleQRCodeScanError}
              delay={300}
              facingMode="environment"
              className="qr-code-scanner"
              onFocus={this.onInputFocus}
              onBlur={this.onInputBlur}
            ></QRComponent>}
            {this.props.field.value && this.props.field.value !== "" &&
              <div className="qr-code-scanner__result"><p>{this.props.field.value || ""}</p></div>}
            {!this.state.hasFocus && FormControlHelpers.invalidFeedbackComponent(this)}
          </div>
          {this.props.formFieldDefinition.hasPopover === undefined &&
            this.props.formFieldDefinition.explanation &&
            this.props.formFieldDefinition.explanation !== "" ? <span className="form-control-plaintext-explanation">{ReactHtmlParser(this.props.formFieldDefinition.explanation)}</span> : null}
        </div>
        <div className={Slug.fromString(this.props.formFieldDefinition.name) + "-input-form-group-after" + " form-group-after "}></div>
      </>
    );
  }
}

export { QRCodeScanner };
